import ITableName from "../../interfaces/ITableName";

class ConfigCurrency implements ITableName {
  id?: number = -1;
  currency: string = "";
  currency_code: string = "";
  symbol: string = "";

  static getTableNameStatic(): string {
    return "config_currency";
  }

  getTableName(): string {
    return ConfigCurrency.getTableNameStatic();
  }
}

export default ConfigCurrency;
